import { useEffect } from "react";

export function useNormalizeItems(
  itemsCount,
  location,
  setShopItems,
  setRideItems,
  setRentItems
) {
  useEffect(() => {
    if (!itemsCount) {
      return;
    }
    const newRentItems = {};
    const newShopItems = {};
    const newRideItems = {};

    Object.keys(itemsCount).forEach((key) => {
      const item = itemsCount[key].item;
      if (item.type === "system") {
      } else if (item.type === "shop") {
        item.table_items.forEach((tableItem, index) => {
          const newItem = { ...item };
          newItem.table_items = [tableItem];
          const price = tableItem[location + "_currency"];

          if (price) {
            newItem[location + "_currency"] = price;
          }
          if (tableItem.image.url) {
            newItem.image = tableItem.image.url;
          }
          if (tableItem.title) {
            newItem.title = tableItem.title;
          }

          newShopItems[key + "-" + index] = {
            item: newItem,
            count: itemsCount[key].count,
          };
        });
      } else if (item.type === "ride") {
        newRideItems[key] = itemsCount[key];
      } else {
        item.table_items.forEach((tableItem, index) => {
          const newItem = { ...item };
          newItem.table_items = [tableItem];
          const price = tableItem[location + "_currency"];

          if (price) {
            newItem[location + "_currency"] = price;
          }
          if (tableItem.image.url) {
            newItem.image = tableItem.image.url;
          }
          if (tableItem.title) {
            newItem.title = tableItem.title;
          }

          newRentItems[key + "-" + index] = {
            item: newItem,
            count: itemsCount[key].count,
          };
        });
      }
    });

    setShopItems(newShopItems);
    setRideItems(newRideItems);
    setRentItems(newRentItems);
  }, [itemsCount, location, setShopItems, setRideItems, setRentItems]);
}
